/* istanbul ignore file */

export { EventsPage as default } from "./EventsPage";
